import Vue from 'vue';
export default {
  // 存下貼文牆的貼文陣列
  SET_POST_WALL_DATA(state, response) {
    let totalArray = state.postWallData.concat(response);
    Vue.set(state, 'postWallData', [...totalArray]);
  },

  // 清空目前貼文牆的資料陣列
  CLEAR_POST_WALL_DATA(state) {
    Vue.set(state, 'postWallData', []);
    state.postPageIndex = 0;
  },

  // 紀錄目前 load 到的貼文牆頁數
  UPDATE_POST_WALL_PAGE_INDEX(state) {
    state.postPageIndex += 1;
  },

  // 更新 API loading 狀態
  UPDATE_POST_WALL_LOAD_STATUS(state, data) {
    state.isFinishLoad = data;
  },

  // 前端刪除貼文
  DELETE_STATE_POST_DATA(state, id) {
    // 用 id 去找 要改哪一個索引的 postWallData
    let idIndex = state.postWallData
      .map(item => {
        return item.PostId;
      })
      .indexOf(id);
    state.postWallData.splice(idIndex, 1);
  },

  // 更新某篇文的按讚狀態
  UPDATE_POST_LIKE_STATUS(state, data) {
    // 用 id 去找 要改哪一個索引的 postWallData
    let idIndex = state.postWallData
      .map(item => {
        return item.PostId;
      })
      .indexOf(data.postId);
    state.postWallData[idIndex].LikeIt = data.flag;
    // 讚數 + 或 - 1
    if (data.flag === 1) {
      state.postWallData[idIndex].LikeCount += 1;
    } else {
      state.postWallData[idIndex].LikeCount -= 1;
    }
  },

  // 前端隱藏當下執行的 隱藏此則動態
  HIDE_STATE_POST_DATA(state, id) {
    // 用 id 去找 要改哪一個索引的 postWallData
    let idIndex = state.postWallData
      .map(item => {
        return item.PostId;
      })
      .indexOf(id);
    state.postWallData.splice(idIndex, 1);
  },

  // 前端隱藏當下執行的 隱藏全部動態
  HIDE_STATE_ALL_POST_DATA(state, id) {
    state.postWallData = state.postWallData.filter(f => f.MemObj.FriendLaleId != id);
  },

  // 更新貼文牆的留言數
  UPDATE_POST_WALL_REPLY_COUNT(state, data) {
    let idIndex = state.postWallData
      .map(item => {
        return item.PostId;
      })
      .indexOf(data.postId);
    // 若目前貼文牆上沒有此篇貼文 ID 則不需執行
    if (idIndex > -1) {
      state.postWallData[idIndex].ReplyCount = data.replyCount;
    }
  }
};
